export const getEvupUnitId = references => {
  if (!Array.isArray(references)) return '';
  const reference = references.find(item => item && item.entity === 'EVUP');
  return reference && reference.value != null ? String(reference.value) : '';
};

export const isValidEvupUnitId = value => {
  const normalized = String(value == null ? '' : value).trim();
  return normalized === '' || /^[1-9][0-9]*$/.test(normalized);
};

export const validateEvupUnitId = value => (
  isValidEvupUnitId(value) ? undefined : 'El ID de unidad EVUP debe ser un entero positivo.'
);

export const setEvupUnitId = (references, value) => {
  const source = Array.isArray(references) ? references : [];
  const normalized = String(value == null ? '' : value).trim();
  let replaced = false;

  const nextReferences = source.reduce((result, reference) => {
    if (!reference || reference.entity !== 'EVUP') {
      result.push(reference);
    } else if (normalized && !replaced) {
      result.push({ ...reference, entity: 'EVUP', value: normalized });
      replaced = true;
    }
    return result;
  }, []);

  if (normalized && !replaced) {
    nextReferences.push({ entity: 'EVUP', value: normalized });
  }

  return nextReferences;
};

export const buildStoreSavePayload = values => {
  const { evupUnitId, references, ...storeValues } = values || {};
  return {
    ...storeValues,
    references: setEvupUnitId(references, evupUnitId)
  };
};
